import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import TagIcon from "../../icons/TagIcon"

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		// justifyContent: 'center',
		flexWrap: 'wrap',
		listStyle: 'none',
		color: '#F00',
		justifyContent: 'start',
		padding: '0 12px'
	},

	chip: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		// backgroundColor: '#BCBBD0',
		fontSize: 13,
		lineHeight: '16px',
		color: '#8987A2',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,
		'& > span': {
			padding: 0
		},
	},

	li: {
		margin: '0 3.5px',

		'&:first-child': {
			marginLeft: 0
		},

		'&:last-child': {
			marginRight: 0
		},
	},

	topTagArray: {
		padding: '0 0 8px 0 !important',
		justifyContent: 'flex-end',
	},

	middleTagArray: {
		padding: '0 !important',
	},

	bottomTagArray: {
		padding: '0 12px !important',
	}
}));

export default function ChipsArray(props) {
	const classes = useStyles();
	
	return (
		<Grid
			item
			lg={12} md={12} sm={12}
			component="ul"
			className={clsx(classes.root, {
				[classes.topTagArray]: props.position === 'top',
				[classes.middleTagArray]: props.position === 'middle',
				[classes.bottomTagArray]: props.position === 'bottom',
			})}
			style={{ alignItems: 'center' }}
		>
			{props.icon === true
				?
				<Grid item style={{ height: 16, width: 16, marginRight: 4 }}>
					<TagIcon fill='#BCBBD0' />
				</Grid>
				:
				''
			}

			{props.Tags && props.Tags.includes(',') && props.Tags.split(',').map((data,ind) => {
				return (
					<li key={data+ind} className={classes.li}>
						<Chip key={'_tags'+ind}
							// style={{ backgroundColor: data.bgcolor }}
							label={data}
							className={classes.chip}
						/>
					</li>
				);
			})}
		</Grid>
	);
}